import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const DiscountOffer = () => {
    const [show, setShow] = useState(false);
    const [isPaused, setIsPaused] = useState(false);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    const navigate = useNavigate();

    const handleRedirect = () => {
        navigate("/contact"); // Redirect to "/about"
    };

    // Track window resize for responsive adjustments
    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (!isPaused) {
            const interval = setInterval(() => {
                setShow(true);
            }, 1000);
            return () => clearInterval(interval);
        }
    }, [isPaused]);

    const handleClose = () => {
        setShow(false);
        setIsPaused(true);
        setTimeout(() => {
            setIsPaused(false);
        }, 50000);
    };

    // Responsive styles based on screen size
    const getResponsiveStyles = () => {
        const isMobile = windowWidth < 768;

        return {
            modalBody: {
                background: "linear-gradient(135deg, #1a1a1a, #2c3e50)",
                padding: isMobile ? "2rem 1rem" : "3rem",
                borderRadius: isMobile ? "15px" : "20px",
                border: "none",
                position: "relative",
                overflow: "hidden",
                width: isMobile ? "95%" : "auto",
                margin: "auto"
            },
            title: {
                fontSize: isMobile ? "2.5rem" : "3.5rem",
                fontWeight: "800",
                background: "linear-gradient(45deg, #FFD700, #FFA500)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                marginBottom: isMobile ? "0.5rem" : "1rem",
                textShadow: "2px 2px 4px rgba(0,0,0,0.3)",
                animation: "slideDown 0.5s ease-out",
                textAlign: "center",
                lineHeight: 1.2
            },
            subtitle: {
                color: "#fff",
                fontSize: isMobile ? "1.2rem" : "1.4rem",
                marginBottom: isMobile ? "1.5rem" : "2rem",
                animation: "fadeIn 0.8s ease-out",
                textAlign: "center",
                padding: "0 10px"
            },
            button: {
                background: "linear-gradient(45deg, #FFD700, #FFA500)",
                border: "none",
                padding: isMobile ? "10px 25px" : "12px 35px",
                fontSize: isMobile ? "1.1rem" : "1.2rem",
                fontWeight: "bold",
                borderRadius: "30px",
                transition: "transform 0.3s, box-shadow 0.3s",
                animation: "bounceIn 1s ease-out",
                width: isMobile ? "80%" : "auto",
                maxWidth: "300px"
            },
            closeButton: {
                padding: isMobile ? "15px" : "10px",
                fontSize: isMobile ? "28px" : "24px",
                top: isMobile ? "5px" : "15px",
                right: isMobile ? "5px" : "15px"
            }
        };
    };

    const styles = getResponsiveStyles();

    return (
        <>
            <style>
                {`
                    @keyframes twinkle {
                        0% { opacity: 1; }
                        50% { opacity: 0.3; }
                        100% { opacity: 1; }
                    }
                    
                    @keyframes slideDown {
                        from { transform: translateY(-20px); opacity: 0; }
                        to { transform: translateY(0); opacity: 1; }
                    }
                    
                    @keyframes fadeIn {
                        from { opacity: 0; }
                        to { opacity: 1; }
                    }
                    
                    @keyframes bounceIn {
                        0% { transform: scale(0.3); opacity: 0; }
                        50% { transform: scale(1.05); opacity: 0.8; }
                        70% { transform: scale(0.9); opacity: 0.9; }
                        100% { transform: scale(1); opacity: 1; }
                    }
                    
                    .custom-close-button {
                        position: absolute;
                        background: none;
                        border: none;
                        color: white;
                        cursor: pointer;
                        transition: transform 0.3s;
                        z-index: 1000;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        touch-action: manipulation;
                    }
                    
                    .custom-close-button:hover {
                        transform: rotate(90deg);
                    }
                    
                    .book-now-btn {
                        touch-action: manipulation;
                        -webkit-tap-highlight-color: transparent;
                    }
                    
                    .book-now-btn:hover {
                        transform: translateY(-3px);
                        box-shadow: 0 5px 15px rgba(255, 215, 0, 0.4);
                    }
                    
                    .book-now-btn:active {
                        transform: translateY(1px);
                    }
                    
                    @media (max-width: 768px) {
                        .modal-dialog {
                            margin: 0.5rem;
                        }
                        
                        .modal-content {
                            touch-action: manipulation;
                        }
                    }
                `}
            </style>
            <Modal
                show={show}
                onHide={handleClose}
                centered
                contentClassName="bg-transparent border-0"
                dialogClassName="modal-dialog-centered"
            >
                <Modal.Body style={styles.modalBody}>
                    <button
                        className="custom-close-button"
                        onClick={handleClose}
                        style={styles.closeButton}
                    >
                        ×
                    </button>

                    <div className="d-flex flex-column align-items-center">
                        <h2 style={styles.title}>
                            Get 15% OFF
                        </h2>
                        <p style={styles.subtitle}>
                            On your First Appointment
                        </p>
                        <Button
                            className="book-now-btn"
                            style={styles.button}
                            onClick={() => {
                                handleClose();
                                handleRedirect();

                            }}
                        >
                            Book Now
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default DiscountOffer;